import React, { useState, useMemo, useEffect } from 'react';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { getPlans, getUsers } from '../../data/mockData';
import PlanCard from '../../components/plans/PlanCard';
import PlanFormModal from '../../components/plans/PlanFormModal';
import AssignPlanModal from '../../components/plans/AssignPlanModal';
import ConfirmationDialog from '../../components/shared/ConfirmationDialog';
import FloatingActionButton from '../../components/shared/FloatingActionButton';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
import useDidFetch from '../../custom_hooks/useDidfetch';

const PlanManagementPage = ({ isAdmin = true }) => {
    const [plans, setPlans] = useState([]);
    const [users, setUsers] = useState([]); // For assign modal

    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const [editingPlan, setEditingPlan] = useState(null);
    const [assigningPlan, setAssigningPlan] = useState(null);
    const [deactivatingPlan, setDeactivatingPlan] = useState(null);

    const handleAddPlan = () => {
        setEditingPlan(null);
        setIsFormModalOpen(true);
    };

    const handleEditPlan = (plan) => {
        setEditingPlan(plan);
        setIsFormModalOpen(true);
    };

    const handleDeactivatePlan = (plan) => {
        setDeactivatingPlan(plan);
        setIsConfirmOpen(true);
    };

    const handleAssignPlan = (plan) => {
        setAssigningPlan(plan);
        setIsAssignModalOpen(true);
    };
    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllPlans();
            getAllUser();
        });
    }, []);
    const getAllUser = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getUser);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setUsers(result?.users ?? []);
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    const getAllPlans = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getPlan);
            const result = response?.data;
            console.log(response);
            if (response.status === 200 || response.status === 201) {
                setPlans(result ?? []);
            }
        } catch (error) {
            console.error("plans get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const confirmDeactivate = async () => {
        try {
            const response = await api.delete(`${ENDPOINTS.deletePlan}/${deactivatingPlan?.id}`);
            const result = response?.data;
            if (response.status === 200 || response.status === 201) {
                toast.success(`Plan "${deactivatingPlan.name}" has been Deleted.`);
                setIsConfirmOpen(false);
                setDeactivatingPlan(null);
                getAllPlans();
            } else {
                console.error("else---->>>>> ", error);
                toast.error(result?.message);
            }
        } catch (error) {
            console.error("save || Edit Plan ", error);
        }
    };

    const handleSavePlan = async (planData) => {
        console.log(planData);
        console.log(editingPlan);
        console.log(`${ENDPOINTS.updatePlan}/${planData?.id}`);
        try {
            const response = editingPlan ? await api.put(`${ENDPOINTS.updatePlan}/${planData?.id}`, planData) : await api.post(ENDPOINTS.savePlan, planData);
            const result = response?.data;
            if (response.status === 200 || response.status === 201) {
                toast.success(result?.message || "Plan has been Created!");
                setIsFormModalOpen(false);
                setEditingPlan(null);
                getAllPlans();
            } else {
                console.error("else---->>>>> ", error);
                toast.error(result?.message);
            }
        } catch (error) {
            console.error("save || Edit Plan ", error);
        }
        // if (editingPlan) {
        //     // Edit
        //     setPlans(plans.map(p => p.id === editingPlan.id ? { ...p, ...planData } : p));
        //     toast.success('Plan updated successfully.');
        // } else {
        //     // Add
        //     const newPlan = { id: `PLN-${Date.now()}`, ...planData };
        //     setPlans([newPlan, ...plans]);
        //     toast.success('Plan added successfully.');
        // }
        // setIsFormModalOpen(false);
        // setEditingPlan(null);
    };

    const handleSaveAssignment = async (assignmentData) => {
        console.log("Assignment Data:", assignmentData);
        let obj = {
            "user_id": assignmentData?.userId,
            "plan_id": assignmentData?.planId,
            "start_date": assignmentData?.startDate,
            "end_date": assignmentData?.endDate,
            "notes": assignmentData?.notes,
        } 

        try {
            const response = await api.post(ENDPOINTS.assignPlan, obj);
            const result = response?.data;
            if (response.status === 200 || response.status === 201) {
                toast.success(`Plan "${assignmentData.planName}" assigned Successfully`);
            setIsAssignModalOpen(false);
            }
        } catch (error) {
            console.log("assign plan error", error);
        } finally {
            // setActivePlan(null);
        }

    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.05
            }
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
        >
            <h1 className="text-3xl font-bold font-display text-gray-800">Plan Management</h1>

            <motion.div
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {plans.length  == 0 && <div className="p-5">No Plan Found</div>  }
                {plans.map(plan => (
                    <PlanCard
                        key={plan.id}
                        plan={plan}
                        onEdit={() => handleEditPlan(plan)}
                        onAssign={() => handleAssignPlan(plan)}
                        onDeactivate={() => handleDeactivatePlan(plan)}
                        showEdit={isAdmin}
                    />
                ))}
            </motion.div>
            {isAdmin &&
                <FloatingActionButton onClick={handleAddPlan}>
                    <Plus size={24} />
                </FloatingActionButton>
            }

            <PlanFormModal
                isOpen={isFormModalOpen}
                onClose={() => setIsFormModalOpen(false)}
                onSave={handleSavePlan}
                plan={editingPlan}
            />

            <AssignPlanModal
                isOpen={isAssignModalOpen}
                onClose={() => setIsAssignModalOpen(false)}
                onAssign={handleSaveAssignment}
                plan={assigningPlan}
                users={users.filter(u => u.role?.name === 'member')}
                plans={plans}
            />

            <ConfirmationDialog
                isOpen={isConfirmOpen}
                onClose={() => setIsConfirmOpen(false)}
                onConfirm={confirmDeactivate}
                title={`Confirm Delete`}
                description={`Are you sure you want to Delete the "${deactivatingPlan?.name}" plan?`}
            />
        </motion.div>
    );
};

export default PlanManagementPage;
